import React, { useState, useEffect, useRef } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
// import AccountantLayout from './AccountantLayout';
import { FaSearch, FaCopy, FaFileExcel, FaPrint, FaTrash, FaCheckCircle, FaTimesCircle, FaEye, FaTimes } from 'react-icons/fa';
import * as XLSX from 'xlsx';

const STATUS_CONFIG = {
    Accepted:  { dot: 'bg-green-500',  text: 'text-green-700',  bg: 'bg-green-50',  border: 'border-green-200',  label: 'Accepted' },
    Rejected:  { dot: 'bg-red-500',    text: 'text-red-700',    bg: 'bg-red-50',    border: 'border-red-200',    label: 'Rejected' },
    Pending:   { dot: 'bg-orange-400', text: 'text-orange-700', bg: 'bg-orange-50', border: 'border-orange-200', label: 'Pending' },
};

const ChallanStatusBadge = ({ status }) => {
    const s = STATUS_CONFIG[status] || STATUS_CONFIG.Pending;
    return (
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-black border uppercase tracking-wider ${s.bg} ${s.text} ${s.border}`}>
            {s.label}
        </span>
    );
};

// Modal for updating status
const ChallanUpdateModal = ({ isOpen, onClose, data, onStatusUpdate }) => {
    const [status, setStatus] = useState('');
    const [remark, setRemark] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (data) {
            setStatus(data.accountantStatus || 'Pending');
            setRemark(data.accountantRemark || '');
        }
    }, [data]);

    if (!isOpen || !data) return null;

    const handleSave = async () => {
        setSaving(true);
        try {
            await onStatusUpdate(data.id, { accountantStatus: status, accountantRemark: remark });
            onClose();
        } catch (e) {
            console.error(e);
        }
        setSaving(false);
    };

    return (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4 backdrop-blur-sm" onClick={onClose}>
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in duration-200" onClick={e => e.stopPropagation()}>
                <div className="bg-gradient-to-r from-blue-700 to-indigo-800 px-6 py-6 text-white flex justify-between items-center">
                    <div>
                        <h2 className="text-xl font-bold">चलन पडताळणी</h2>
                        <p className="text-[10px] text-blue-100 uppercase tracking-widest font-bold mt-1">{data.name}</p>
                    </div>
                    <button onClick={onClose} className="text-white/80 hover:text-white text-3xl font-light">&times;</button>
                </div>
                
                <div className="p-8 space-y-6">
                    <div className="space-y-2">
                        <label className="text-[11px] font-black text-gray-400 uppercase tracking-widest">पेमेंट स्थिती अपडेट करा</label>
                        <select 
                            value={status} 
                            onChange={e => setStatus(e.target.value)}
                            className="w-full border-2 border-gray-100 rounded-2xl px-5 py-3 text-sm font-bold outline-none focus:border-blue-500 transition-all bg-gray-50"
                        >
                            <option value="Pending">Pending</option>
                            <option value="Accepted">Accepted</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                    </div>

                    <div className="space-y-2">
                        <label className="text-[11px] font-black text-gray-400 uppercase tracking-widest">शेरा / Remark</label>
                        <textarea 
                            rows={3} 
                            placeholder="तुमची टिप्पणी लिहा..." 
                            value={remark}
                            onChange={e => setRemark(e.target.value)}
                            className="w-full border-2 border-gray-100 rounded-2xl px-5 py-3 text-sm outline-none focus:border-blue-500 transition-all bg-gray-50 font-medium"
                        />
                    </div>

                    <div className="flex gap-4 pt-4">
                        <button 
                            onClick={handleSave} 
                            disabled={saving}
                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-2xl text-sm font-black shadow-lg shadow-blue-100 transition-all active:scale-[0.98] disabled:opacity-50"
                        >
                            {saving ? 'प्रक्रिया...' : 'अपडेट करा'}
                        </button>
                        <button onClick={onClose} className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-4 rounded-2xl text-sm font-bold transition-all">
                            रद्द करा
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AccountantShowSubeChallan = () => {
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const navigate = useNavigate();
    const tableRef = useRef(null);

    useEffect(() => {
        const unsubscribeAuth = auth.onAuthStateChanged(user => {
            if (!user) navigate('/login');
        });

        const regRef = ref(db, 'ekamwatapzp/EngineerRegistrations');
        const unsubscribeData = onValue(regRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data).map(key => {
                    const user = data[key];
                    const payment = user.payment || {};
                    const invoice = payment['Registration status invoice'] || {};
                    return {
                        id: key,
                        name: `${user.firstName || ''} ${user.middleName || ''} ${user.surname || ''}`.trim() || 'No Name',
                        phone: user.whatsappNo || user.mobileNo || '-',
                        transactionId: invoice.transactionId || invoice.receiptId || '-',
                        amount: invoice.amount || invoice.paidAmount || '0.0',
                        accountantStatus: invoice.accountantStatus || (invoice.status === 'completed' ? 'Accepted' : 'Pending'),
                        accountantRemark: invoice.accountantRemark || '',
                        submittedAt: user.submittedAt || 0
                    };
                });
                setRegistrations(list.sort((a, b) => b.submittedAt - a.submittedAt));
                setLoading(false);
            } else {
                setRegistrations([]);
                setLoading(false);
            }
        });

        return () => {
            unsubscribeAuth();
            unsubscribeData();
        };
    }, [navigate]);

    const handleStatusUpdate = async (id, updateData) => {
        const itemRef = ref(db, `ekamwatapzp/EngineerRegistrations/${id}/payment/Registration status invoice`);
        await update(itemRef, updateData);
    };

    const filteredData = registrations.filter(item => {
        const searchSource = `${item.name} ${item.phone} ${item.transactionId}`.toLowerCase();
        return searchSource.includes(searchTerm.toLowerCase());
    });

    const handleCopy = () => {
        const rows = filteredData.map((item, i) =>
            [i + 1, item.name, item.phone, item.transactionId, item.amount, item.accountantStatus].join('\t')
        ).join('\n');
        navigator.clipboard.writeText(rows);
    };

    const handleExcel = () => {
        const wsData = [
            ['क्र.', 'अर्जदाराचे नाव', 'फोन क्र.', 'ट्रांझॅक्शन आयडी', 'रक्कम', 'अकाऊंटंट फी चलन स्थिती'],
            ...filteredData.map((item, i) => [i + 1, item.name, item.phone, item.transactionId, item.amount, item.accountantStatus])
        ];
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'नवीन सु.बे. अभियंता चलन');
        XLSX.writeFile(wb, 'New_Engineer_Challans.xlsx');
    };

    const handlePrint = () => window.print();

    if (loading) return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
        </div>
    );

    return (
        <div className="min-h-screen bg-[#f4f7fa] p-4 md:p-8">
            <div className="p-8 bg-[#fdfdfd] min-h-screen">
                {/* Header Container */}
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
                    <h1 className="text-2xl font-bold text-gray-800 tracking-tight">नवीन सु.बे. अभियंत्यांची यादी</h1>
                    <div className="text-[13px] text-gray-400 font-bold uppercase tracking-widest">
                        ठाणे जिल्हा परिषद / <span className="text-blue-600">नवीन सु.बे. अभियंत्यांची यादी</span>
                    </div>
                </div>

                <div className="bg-white rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.02)] border border-gray-100 overflow-hidden">
                    {/* Status Legend & Counts */}
                    <div className="px-8 py-6 border-b border-gray-50 flex flex-col md:flex-row md:items-center justify-between gap-6">
                        <div className="flex items-center gap-6">
                            <div className="flex items-center gap-2">
                                <span className="w-3 h-3 rounded-full bg-orange-400 shadow-sm animate-pulse"></span>
                                <span className="text-[13px] font-bold text-gray-500">Pending</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="w-3 h-3 rounded-full bg-green-500 shadow-sm"></span>
                                <span className="text-[13px] font-bold text-gray-500">Accepted</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="w-3 h-3 rounded-full bg-red-500 shadow-sm"></span>
                                <span className="text-[13px] font-bold text-gray-500">Rejected</span>
                            </div>
                        </div>
                        
                        <div className="flex items-center gap-4 text-xs font-black text-gray-400 uppercase tracking-widest bg-gray-50/80 px-5 py-2.5 rounded-2xl">
                            <span>एकूण {filteredData.length} चलन सापडले</span>
                        </div>
                    </div>

                    {/* Toolbar & Search */}
                    <div className="px-8 py-5 flex flex-col lg:flex-row lg:items-center justify-between gap-6 bg-white">
                        <div className="flex gap-2.5">
                            <button onClick={handleCopy} className="flex items-center gap-2 bg-[#718096] hover:bg-[#4a5568] text-white text-[11px] font-black px-5 py-2.5 rounded-xl transition-all active:scale-95 shadow-md shadow-gray-100 uppercase tracking-wider">
                                <FaCopy /> Copy
                            </button>
                            <button onClick={handleExcel} className="flex items-center gap-2 bg-[#38a169] hover:bg-[#2f855a] text-white text-[11px] font-black px-5 py-2.5 rounded-xl transition-all active:scale-95 shadow-md shadow-green-100 uppercase tracking-wider">
                                <FaFileExcel /> Excel
                            </button>
                            <button onClick={handlePrint} className="flex items-center gap-2 bg-[#2d3748] hover:bg-black text-white text-[11px] font-black px-5 py-2.5 rounded-xl transition-all active:scale-95 shadow-md shadow-gray-100 uppercase tracking-wider">
                                <FaPrint /> Print
                            </button>
                        </div>

                        <div className="relative group flex-grow lg:flex-none">
                            <div className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-300 group-focus-within:text-blue-500 transition-colors">
                                <FaSearch size={14} />
                            </div>
                            <input 
                                type="text"
                                placeholder="Search: अर्जदार, फोन किंवा आयडी..."
                                className="w-full lg:w-72 pl-14 pr-6 py-3 bg-gray-50/50 border-2 border-gray-50 rounded-2xl text-[13px] font-bold text-gray-700 placeholder:text-gray-300 focus:bg-white focus:border-blue-500/10 focus:ring-4 focus:ring-blue-500/5 outline-none transition-all"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Desktop Table View */}
                    <div className="overflow-x-auto" ref={tableRef}>
                        <table className="w-full text-left">
                            <thead className="bg-[#fcfdfe]">
                                <tr className="text-[11px] font-black text-gray-400 uppercase tracking-[0.15em] border-y border-gray-50">
                                    <th className="px-8 py-5 text-center w-20">क्र. ↑</th>
                                    <th className="px-8 py-5">अर्जदाराचे नाव ↑↓</th>
                                    <th className="px-8 py-5">फोन क्र. ↑↓</th>
                                    <th className="px-8 py-5">ट्रान्झॅक्शन आयडी ↑↓</th>
                                    <th className="px-8 py-5 text-center">रक्कम ↑↓</th>
                                    <th className="px-8 py-5 text-center">अकाऊंटंट फी चलन स्थिती ↑↓</th>
                                    <th className="px-8 py-5 text-center">चलन अपडेट करा / पहा ↑↓</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {filteredData.map((item, index) => (
                                    <tr key={item.id} className="hover:bg-blue-50/10 transition-colors group">
                                        <td className="px-8 py-6 text-center text-sm font-black text-gray-300 italic group-hover:text-blue-400 transition-colors">{index + 1}</td>
                                        <td className="px-8 py-6">
                                            <div className="text-sm font-bold text-gray-700 group-hover:text-blue-700 transition-colors uppercase tracking-tight">{item.name}</div>
                                            {item.accountantRemark && (
                                                <div className="text-[10px] text-orange-400 font-bold mt-1 italic opacity-0 group-hover:opacity-100 transition-opacity">
                                                    "{item.accountantRemark}"
                                                </div>
                                            )}
                                        </td>
                                        <td className="px-8 py-6">
                                            <div className="text-[13px] font-bold text-gray-500">{item.phone}</div>
                                        </td>
                                        <td className="px-8 py-6">
                                            <div className="text-[11px] font-black text-blue-600/70 bg-blue-50/50 px-3 py-1 rounded-lg inline-block font-mono tracking-tighter">
                                                {item.transactionId}
                                            </div>
                                        </td>
                                        <td className="px-8 py-6 text-center">
                                            <div className="text-sm font-black text-gray-700">{item.amount}</div>
                                        </td>
                                        <td className="px-8 py-6 text-center">
                                            <ChallanStatusBadge status={item.accountantStatus} />
                                        </td>
                                        <td className="px-8 py-6">
                                            <div className="flex items-center justify-center gap-3">
                                                <button 
                                                    onClick={() => {
                                                        setSelectedItem(item);
                                                        setIsModalOpen(true);
                                                    }}
                                                    className="p-2.5 rounded-xl bg-gray-50 hover:bg-blue-50 text-gray-400 hover:text-blue-600 transition-all border border-transparent hover:border-blue-100 active:scale-90"
                                                    title="Update Status"
                                                >
                                                    <FaTimes size={14} />
                                                </button>
                                                <button 
                                                    onClick={() => navigate(`/accountant/subhe-new/documents/${item.id}`)}
                                                    className="p-2.5 rounded-xl bg-gray-50 hover:bg-blue-50 text-gray-400 hover:text-blue-600 transition-all border border-transparent hover:border-blue-100 active:scale-90"
                                                    title="View Challan/Documents"
                                                >
                                                    <FaEye size={14} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        
                        {filteredData.length === 0 && (
                            <div className="p-24 text-center">
                                <div className="text-gray-200 mb-4 flex justify-center">
                                    <FaSearch size={48} className="opacity-20" />
                                </div>
                                <h3 className="text-lg font-black text-gray-300 uppercase tracking-widest italic animate-pulse">कोणतीही नोंद आढळली नाही</h3>
                            </div>
                        )}
                    </div>

                    {/* Footer Info */}
                    <div className="px-8 py-4 bg-gray-50/30 border-t border-gray-50 flex justify-between items-center text-[10px] font-black text-gray-400 uppercase tracking-widest">
                        <span>ZP THANE ACCOUNTANT PORTAL</span>
                        <span>© 2026 EKAM WATAP</span>
                    </div>
                </div>

                <ChallanUpdateModal 
                    isOpen={isModalOpen} 
                    onClose={() => setIsModalOpen(false)} 
                    data={selectedItem} 
                    onStatusUpdate={handleStatusUpdate}
                />
            </div>
            
            {/* Print Styling */}
            <style dangerouslySetInnerHTML={{ __html: `
                @media print {
                    nav, button, .lg\\:flex-none, .status-legend { display: none !important; }
                    .p-8 { padding: 0 !important; }
                    .shadow-sm, .rounded-[2rem] { box-shadow: none !important; border: 1px solid #eee !important; border-radius: 0 !important; }
                    table { width: 100% !important; border-collapse: collapse !important; }
                    th, td { border: 1px solid #f0f0f0 !important; font-size: 10px !important; }
                    body { background: white !important; }
                }
            `}} />
        </div>
    );
};

export default AccountantShowSubeChallan;
